import { Part } from '@/Engine/Part';
import { $ } from '@/Engine/state';
import { getHolesForSelectedModel, getIndexInHoles } from '@/Engine/eventHandlers/libs/getHoles';

export function calculatePosition(obj: Part) {
    const holes = getHolesForSelectedModel(obj);
    let holesX = [ 0 ];
    let holesY = holes;
    if (obj.key === 'accessory') {
        if (holes === undefined || holes.x === undefined || holes.y === undefined) return;
        holesX = [ ...holes.x ];
        holesY = [ ...holes.y ];
    }

    const indexY = getIndexInHoles(holesY, $.pointerVirtual.y);
    const indexX = getIndexInHoles(holesX, $.pointerVirtual.x);
    if (indexY !== -1) obj._indexPositionY = indexY;
    if (indexX !== -1) obj._indexPositionX = indexX;
}
export function calculatePositionY(obj: Part, pointerPositionY: number) {
    if (obj.key !== 'accessory') return;
    const holesY = getHolesForSelectedModel(obj);
    const indexY = getIndexInHoles(holesY.y, pointerPositionY);
    if (indexY !== -1) obj._indexPositionY = indexY;
}
export function calculatePositionX(obj: Part, pointerPositionX?: number) {
    const holes = getHolesForSelectedModel(obj);
    let holesX = [ 0 ];
    if (obj.key === 'accessory') {
        if (holes === undefined || holes.x === undefined || holes.y === undefined) return;
        holesX = [ ...holes.x ];
    }

    const indexX = getIndexInHoles(holesX, pointerPositionX ?? $.pointerVirtual.x);
    if (indexX !== -1) obj._indexPositionX = indexX;
}
